import { ComponentProps } from "react";
import { RouteFactory } from "@app/routePaths";
import Card from "@particles/card/Card";
import { useListingLoadMoreStories } from "@particles/listing/hooks/useListingLoadMoreStories";
import { getBTLuxeCardProps } from "@routes/Section/layouts/BTLuxe/utils/helpers";

import LifestyleLuxeArticles from "./BTLuxeListingCard";

type BTLuxeListingProps = {
  /** The card props to be displayed. */
  cardProps: ComponentProps<typeof Card>[];
  /** The article ids to be excluded. */
  articleIds: string[];
  /** The todays season. */
  todaysSeason?: string;
};

const PAGE_SIZE = 12;

const BTLuxeListing = ({
  cardProps,
  articleIds,
}: BTLuxeListingProps): React.ReactElement => {
  const { ref, loadMoreData } = useListingLoadMoreStories({
    templateProps: getBTLuxeCardProps,
    initialList: cardProps,
    urlPath: RouteFactory.lifestyleLuxe,
    pageType: "section",
    size: PAGE_SIZE,
    sections: "lifestyle_bt-luxe",
    offset: 0,
    excludeIds: articleIds,
  });

  const stories = [...cardProps, ...loadMoreData];

  return (
    <>
      <div className="grid grid-cols-1 gap-0 md:grid-cols-6 md:gap-x-6 md:gap-y-12 md:pt-9 lg:gap-x-8">
        {stories.map((story, index) => {
          return (
            <LifestyleLuxeArticles
              key={story.id}
              cardProp={story}
              index={index}
              initialLength={cardProps.length}
              allCardProps={stories}
            />
          );
        })}
      </div>

      <div data-testid="listing-load-more-stories-ref" ref={ref} />
    </>
  );
};

export default BTLuxeListing;
